(function () {
    'use strict';

    var gettext = angular.identity;

    angular
        .module('app.memberAdmin')
        .constant('defaultMemberDetailPageSize', 10)
        .enumeration('handicapSuffix', {
            Modify: [, gettext('Modify')],
            Limit: [, gettext('Limit')],
            Withdraw: [, gettext('Withdraw')],
            ModifyLow: [, gettext('Modify Low')], 
        })
        .constant('memberLookupPageSize', 20)
        .constant('memberLookupPlaceholder', gettext('Enter "last, first name" or card #.'))
        .constant('handicapHistoryFilters', [
            { value: -30, text: gettext('30 days') },
            { value: -90, text: gettext('90 days') },
            { value: -180, text: gettext('180 days') },
            { value: -365, text: gettext('1 Year') },
            { value: -730, text: gettext('2 Years') },
            { value: -1095, text: gettext('3 Years') }
        ])


        .enumeration('attributeType', {
            IncidentProtectionEquipment: [, gettext('Incident Protection Claim Equipment')],
            IncidentProtectionDeductible: [, gettext('Incident Protection Claim Deductible')],
            IncidentProtectionCart: [, gettext('Incident Protection Claim Cart')],
            IncidentProtectionTravel: [, gettext('Incident Protection Claim Travel')],
            IncidentProtectionWindows: [, gettext('Incident Protection Claim Windows')],
            HandicapCertification: [, gettext('Handicap Certification')],
            RulesLevel1: [, gettext('Rules of Golf - Level 1')],
            RulesLevel2: [, gettext('Rules of Golf - Level 2')],
            RulesLevel3: [, gettext('Rules of Golf - Level 3')],
            CourseRaterLevel1: [, gettext('Course Rater - Level 1')],
            CourseRaterLevel2: [, gettext('Course Rater - Level 2')],
            CourseRaterLevel3: [, gettext('Course Rater - Level 3')],
            ClubCaptain: [gettext('Club Captain')],
            ClubPresident: [gettext('Club President')]
        })

        .constant('memberAdminResources', {

            memberDetailRequestFailed: gettext('Failed to retrieve member detail from server.'),
            
            requestCardConfirmation: gettext('Request a card for {0}?'),
            requestCardSuccess: gettext('Card has been requested.'),
            requestCardFailed: gettext('Unable to request card for {0}.'),
            sendPasswordEmailConfirmation: gettext('Send password reset link for {0} at {1}?'),
            sendPasswordEmailSuccess: gettext('Password reset link has been sent.'),
            sendPasswordEmailFailed: gettext('Unable to send password reset link to {0} at {1}?'),

            calculateLowHandicapConfirmation: gettext('Update low handicap for {0}?'),
            calculateLowHandicapSuccess: gettext('Low handicap was updated.'),
            calculateLowHandicapFailed: gettext('Unable to update low handicap for {0}.'),
            
            reverseActivationConfirmation: gettext('Reverse the activation, restore the credit, and reset expiration date for {0}?'),
            reverseActivationSuccess: gettext('Activation was reversed.'),
            reverseActivationFailed: gettext('Unable to reverse the activation for {0}.'),

            calculateHandicapConfirmation: gettext('Update handicap for {0}?'),
            calculateHandicapSuccess: gettext('Handicap was updated.'),
            calculateHandicapFailed: gettext('Unable to update handicap for {0}.'),

            sendScoreToUSGAConfirmation: gettext('Do you want to send the scoring record for this golfer to the USGA?'),
            sendScoreToUSGASuccess: gettext('Scoring record was sent to the USGA.'),
            sendScoreToUSGAFailed: gettext('Unable to send scoring record to USGA'),

            fetchMembershipLevelsFailed: gettext('Failed to retrieve membership levels for club.'),
            saveMembershipFailed: gettext('Failed to save club membership.'),
            confirmArchiveMembership: gettext('Are you sure you want to archive this club membership?'),
            archiveMembershipFailed: gettext('Failed to archive club membership.'),
            confirmRestoreMembership: gettext('Are you sure you want to restore this club membership?'),
            restoreMembershipFailed: gettext('Failed to restore club membership.'),

            saveRoleFailed: gettext('Failed to save role.'),
            confirmDeleteRole: gettext('Are you sure you want to delete this role?'),
            deleteRoleFailed: gettext('Failed to delete role.'),

            confirmRemoveIgnMembership: gettext('Are you sure you want to delete this IGN membership?'),
            deleteIgnMembershipFailed: gettext('Failed to delete IGN membership.'),
            saveIgnMembershipFailed: gettext('Failed to save IGN membership.'),

            saveIntegrationFailed: gettext('Failed to save integration record.'),
            confirmDeleteIntegration: gettext('Are you sure you want to delete this integration record?'),
            deleteIntegrationFailed: gettext('Failed to delete integration record.'),

            saveAttributeFailed: gettext('Failed to save attribute record.'),
            confirmDeleteAttribute: gettext('Are you sure you want to delete this attribute record?'),
            deleteAttributeFailed: gettext('Failed to delete attribute record.'),

            modifyHandicapSucceeded: gettext('Handicap updated successfully.'),
            modifyHandicapFailed: gettext('Unable to modify handicap.'),

            adjustScoresSucceeded: gettext('Scores adjusted successfully.'),
            adjustScoresFailed: gettext('Unable to adjust scores.'),

            memberLookupRequestFailed: gettext('Failed to retrieve members from server.'),

            confirmMergeAccounts: gettext('Are you sure you want to merge these two accounts?'),
            mergeAccountsSucceeded: gettext('Accounts merged successfully.'),
            mergeAccountsFailed: gettext('Failed to merge accounts.'),

            confirmRemoveCourseListItem: gettext('Are you sure you want to remove "{0}" from the course list?'),
            addToCourseListFailed: gettext('Failed to add "{0}" to the course list!'),
            removeFromCourseListFailed: gettext('Failed to remove "{0}" from the course list!'),

            impersonationFailed: gettext('Failed to impersonate {0}.'),

            checkInRBCCanadianOpenPlayerSucceeded: gettext('{0} has been checked into the RBC Canadian Open.'),
            checkInRBCCanadianOpenPlayerFailed: gettext('Failed to check "{0}" into the RBC Canadian Open.'),

            handicapHistoryFailed: gettext('Failed to retrieve handicap history!'),
            convertNineToEighteenConfirm: gettext('Convert member from nine hole handicap to eighteen hole handicap?'),
            convertNineToEighteenSuccess: gettext('Member converted successfully.'),
            convertNineToEighteenSuccessFailed: gettext('Unable to convert member.'),
        })
})();
